import React from "react";
import Form from "../../components/StaffTabs/StaffTakeAttendance/Form";


const TakeStudentAttendance = () => {
  return (
    <div>

      <Form/>
    </div>
  );
};

export default TakeStudentAttendance;
